// extracted by mini-css-extract-plugin
export default {"buttons":"DetailsModal_buttons__Zo8oD","alarmsBtn":"DetailsModal_alarmsBtn__x2rJX","mapBtn":"DetailsModal_mapBtn__4ZEb7","sensorsContainer":"DetailsModal_sensorsContainer__cP9vz"};